<template>
  <div id='donwload_overlay' @click='hide()' class="modal fade">
    <div id="content" class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <p class="modal__title">資料請求</p>
        <div class="selectedContainer">
          <p class="selectedContainer__item">選択中の施設</p>
          <div class="selectedContainer__outer">
            <img class="facilityImage" src="../../../../assets/images/senior_home_image.png" v-if="care_home.care_home_image == null || care_home.care_home_image.url == null && care_home.care_home_image.default_image_type == 'senior_home'">
            <img class="facilityImage" src="../../../../assets/images/sakoju_image.png" v-else-if="care_home.care_home_image == null || care_home.care_home_image.url == null && care_home.care_home_image.default_image_type == 'sakoju'">
            <img class="facilityImage" src="../../../../assets/images/image_sonaeru.jpeg" v-else-if="care_home.care_home_image == null || care_home.care_home_image.url == null && care_home.care_home_image.default_image_type == 'others'">
            <img class="facilityImage" :src="care_home.care_home_image.url" v-else>
            <div>
              <ul>
                <li class="place"><i class="fa-sharp fa-light fa-location-dot"></i><span style='font-size: 0.8em;'>{{careHomePrefecture}}</span></li>
                <li class="headerInfoType"><span style='font-size: 0.8em;'>{{careHomeServiceType}}</span></li>
                <li class="headerInfoName">{{careHomeName}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="topicContainer">
            <div class="topicContainer__title">
              <p><span>{{careHomeName}}</span>の資料をダウンロードする</p>
            </div>
            <div class="topicContainer__contents" v-if="care_home.pamphlets.length != 0">
              <p>下記よりご希望の資料をダウンロードいただけます。</p>
              <span style='color:gray; font-size: 0.75em; margin-left:10px;' >(パンフレットは最新ではない可能性がありますので、予めご留意下さい)</span>
              <ul class="downloadPamphlet__list" v-for="(pamphlet, i) in care_home.pamphlets" :key="pamphlet.id" style='margin-top: 15px;'>
                <li>
                  <span class="Pamphlet" style='cursor: pointer;' @click="onPamphletDownload(pamphlet.url, pamphlet.btn_name)">
                    <i class="fa-sharp fa-light fa-file-pdf" style='margin-right: 5px;'></i>{{pamphlet['btn_name']}}
                  </span>
                </li>
              </ul>
            </div>
            <div v-else>
              <p style='margin-left:10px;'>ダウンロード可能なパンフレットがありません</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  name: 'DownloadPamphletModal',
  components: {},
  data() {
    return {
      care_home: {
        id: null,
        name: null,
        pamphlets: []
      }
    }
  },
  computed: {
    ...mapGetters('map', ['mapSelectedMarkerId']),
    careHomeName(){
      return this.care_home.name == null ? null : this.care_home.name
    },
    careHomePrefecture(){
      return this.care_home.name == null ? null : this.care_home.prefecture
    },
    careHomeServiceType(){
      return this.care_home.name == null ? null : this.care_home.service_type
    },
    careHomeInitialPriceRange(){
      return this.care_home.initial_price_range == null ? null : this.care_home.initial_price_range
    },
    careHomeMonthlyPriceRange(){
      return this.care_home.monthly_price_range == null ? null : this.care_home.monthly_price_range
    },
  },
  methods: {
    hide() {
      this.$emit('hideModal')
    },
    async onPamphletDownload(url, name) {
      const res = await axios({
        url: url,
        responseType: 'blob'
      }).then((res) => {
        let mineType = res.headers["content-type"];
        let blob = new Blob([res.data], { type: mineType })
        let blobURL = window.URL.createObjectURL(blob)
        let obj = document.createElement('a')
        obj.href = blobURL
        obj.download = name
        document.body.appendChild(obj)
        obj.click()
        obj.parentNode.removeChild(obj)
      })
    },
  },
  watch: {
    mapSelectedMarkerId: async function(newVal, oldVal){
      if(this.mapSelectedMarkerId != null){
        try {
          const res = await axios.get(`/map/api/care_homes/${this.mapSelectedMarkerId}`)
          this.care_home = res.data.care_home
        } catch(e) {
          alert('error')
        }
      }
    }
  }

}
</script>
